import React from "react";
import Button from "react-bootstrap/Button";
import { ButtonProps } from "react-bootstrap/Button";
import "./index.scss";
import classNames from "classnames";

interface PDLButtonProps extends ButtonProps {
  children: React.ReactNode;
  className?: string | "";
}

const PDLButton: React.FC<PDLButtonProps> = ({
  children,
  className = "",
  ...props
}) => (
  <Button
    {...props}
    className={classNames("pdl_dna_button", className)}
    as={props.as ?? "button"}
  >
    {children}
  </Button>
);

export default PDLButton;
